import { useAuth, useUser } from "@clerk/clerk-react";
import BreachPop from "Components/BreachPop/BreachPop";
import StageWinPop from "Components/StageWinPop/StageWinPop";
import { TooltipProvider } from "Components/ui/tooltip";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter, useLocation } from "react-router-dom";
import { io } from "socket.io-client";
import AllRoutes from "./AllRoutes";
import "./App.css";
import { getStageDetails } from "./Redux/ChallengeOverview/ChallengeOverviewAction";
import { getUser } from "./Redux/Profile/ProfileActions";
import ChallengeClosePopup from "Components/ChallengeClosePopup/ChallengeClosePopup";
import ChallengeWinPopup from "Components/ChallengeWinPopup/ChallengeWinPopup";
import {
  getChallengesRequest,
  getClosedChallenges,
} from "./Redux/ChallengeMain/ChallengeMainActions";
import { RegisterFcmToken } from "./Redux/Notifications/NotificationsAction";
import IntercomComp from "Components/Intercom/Intercom";
import { ThemeProvider } from "./hooks/ThemeContext";

function App() {
  const currentPath = useLocation().pathname;
  const [data, setData] = useState({});
  const [open, setOpen] = useState(false);
  const [openWin, setOpenWin] = useState(false);
  const [winData, setWinData] = useState({});
  const [openClose, setOpenClose] = useState(false);
  const [closeData, setCloseData] = useState({});
  const [openWinChallenge, setOpenWinChallenge] = useState(false);
  const [winChallengeData, setWinChallengeData] = useState({});
  const dispatch = useDispatch();
  const userClerk = useUser()?.user;
  const { isSignedIn, isLoaded } = useUser();

  const { user, getUserLoading } = useSelector((state) => state.ProfileReducer);

  const { challengeStageInfo } = useSelector(
    (state) => state.ChallengeOverviewReducer
  );
  const { getToken, signOut } = useAuth();
  const { pathname } = useLocation();

  useEffect(() => {
    dispatch(getUser(getToken, signOut));
    localStorage.getItem("fcm_token") &&
      isSignedIn &&
      isLoaded &&
      dispatch(RegisterFcmToken(localStorage.getItem("fcm_token"), getToken));
  }, [userClerk, isLoaded, isSignedIn, pathname]);

  useEffect(() => {
    if (
      Object.keys(user)?.length > 0 &&
      !getUserLoading &&
      user?.role != "USER"
    ) {
      signOut();
    } else {
      if (
        Object.keys(user)?.length > 0 &&
        !getUserLoading &&
        user?.role != "ADMIN"
      ) {
        SocketIo.emit("joinRoom", {
          userId: user?.id,
        });
      }
    }
  }, [user]);

  useEffect(() => {
    SocketIo.on("ChallengeFailed", (data) => {
      setOpen(Object?.keys(data).length > 0);
      setData(data);
      if (
        challengeStageInfo?.Challenge?.id == data?.challengeId &&
        data?.challengeId
      )
        dispatch(getStageDetails(getToken, data?.challengeId));

      dispatch(getChallengesRequest(getToken));
      dispatch(getClosedChallenges(getToken));
    });

    SocketIo.on("ChallengeClosed", (data) => {
      setOpenClose(Object?.keys(data).length > 0);
      setCloseData(data);
      if (
        challengeStageInfo?.Challenge?.id == data?.challengeId &&
        data?.challengeId
      )
        dispatch(getStageDetails(getToken, data?.challengeId));
      dispatch(getChallengesRequest(getToken));
      dispatch(getClosedChallenges(getToken));
    });

    SocketIo.on("FreeChallengePassed", (data) => {
      setOpenWinChallenge(Object?.keys(data).length > 0);
      setWinChallengeData(data);
      if (
        challengeStageInfo?.Challenge?.id == data?.challengeId &&
        data?.challengeId
      )
        dispatch(getStageDetails(getToken, data?.challengeId));
      dispatch(getChallengesRequest(getToken));
      dispatch(getClosedChallenges(getToken));
    });

    SocketIo.on("ChallengePassed", (data) => {
      setOpenWin(Object?.keys(data).length > 0);
      setWinData(data);

      if (
        challengeStageInfo?.Challenge?.id == data?.challengeId &&
        data?.challengeId
      )
        dispatch(getStageDetails(getToken, data?.challengeId));
      dispatch(getChallengesRequest(getToken));
      dispatch(getClosedChallenges(getToken));
    });
  }, [challengeStageInfo]);

  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .then((registration) => {
        console.log(
          "Service Worker registered with scope:",
          registration.scope
        );
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error);
      });
  }

  return (
    <ThemeProvider>
      <TooltipProvider>
        <AllRoutes />
        <BreachPop open={open} setOpen={setOpen} data={data} />
        <StageWinPop open={openWin} setOpen={setOpenWin} data={winData} />
        <ChallengeClosePopup
          open={openClose}
          setOpen={setOpenClose}
          data={closeData}
        />
        <ChallengeWinPopup
          open={openWinChallenge}
          setOpen={setOpenWinChallenge}
          data={winChallengeData}
        />
        {user?.id ? <IntercomComp user={user} /> : <IntercomComp />}
      </TooltipProvider>
    </ThemeProvider>
  );
}

export default App;

export const SocketIo = io(process.env.REACT_APP_BACKEND_URL + "", {
  reconnection: true,
  reconnectionDelay: 100000,
  reconnectionDelayMax: 5000,
  reconnectionAttempts: 99999,
});
